import { TabType } from '@aloft/toolkit-sui';

import { MarketConditionsTabPanels } from './tabPanels/MarketConditionsTabPanels.tsx';
import { PriorSalesTabPanels } from './tabPanels/PriorSalesTabPanels.tsx';
import { Tab, TabPanels } from './types.ts';

export const tabs: TabType<Tab>[] = [
  {
    label: 'Market Condition',
    value: 'market-condition',
  },
  {
    label: 'Prior Sales',
    value: 'prior-sales',
  },
];

export const tabPanelsMap: Partial<Record<Tab, TabPanels>> = {
  'market-condition': {
    Left: () => <MarketConditionsTabPanels.LeftPanel />,
    Right: () => <MarketConditionsTabPanels.RightPanel />,
  },
  'prior-sales': {
    Left: () => <PriorSalesTabPanels.LeftPanel />,
    Right: () => <PriorSalesTabPanels.RightPanel />,
  },
};
